import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetColumnType } from '../bet-column/bet-column-type';

@Injectable({ providedIn: 'root' })
export class MiniGamesTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackMiniGames(tab: BetColumnType): void {
        switch (tab) {
            case BetColumnType.Betslip: {
                this.trackGameStartedWhenBetSlipOpen();
                break;
            }
            case BetColumnType.MyBets: {
                this.trackGameStartedWhenMyBetsOpen();
                break;
            }
        }
    }

    private trackGameStartedWhenBetSlipOpen(): void {
        this.trackingService.track(trackingConstants.EVENT_MINI_GAME_OPEN, {
            [trackingConstants.PAGE_DISPLAYED_ELEMENT]: 'MiniGames_Start_SlipOpen',
        });
    }

    private trackGameStartedWhenMyBetsOpen(): void {
        this.trackingService.track(trackingConstants.EVENT_MINI_GAME_OPEN, {
            [trackingConstants.PAGE_DISPLAYED_ELEMENT]: 'MiniGames_Start_MyBetsOpen',
        });
    }
}
